import { pmFetchJson } from "@penmate/react-shared/api/pmFetch";
import type { Facility } from "@penmate/react-shared/api/facilities";

// Resolve a facility arriving by id on an inbound link (facility-page cards).
// Authenticated endpoint — callers resolve once auth is known; failures mean
// "no pre-selection", never an error surface.
export async function findFacilityById(id: string | number): Promise<Facility | null> {
  try {
    const res = await pmFetchJson<Facility[]>("/find-facility", { params: { id } });
    return Array.isArray(res) && res.length > 0 && res[0] && res[0].id ? res[0] : null;
  } catch {
    return null;
  }
}
